import { $api } from '@/api/typedClient'
import { message } from 'antd'

export function useDismissUserTask() {
  return $api.useMutation('post', '/user_task/dismiss', {
    onError: (error) => {
      message.error(`Failed to dismiss task: ${JSON.stringify(error)}`)
    },
  })
}
